import { paths } from "./paths.config";

export const sizes = {
  Small: {
    width: 1280 * 5,
    height: 768 * 5,
  },
  Medium: {
    width: 1280 * 10,
    height: 768 * 10,
  },
  Large: {
    width: 1280 * 20,
    height: 768 * 20,
  },
};

export const backgrounds = {
  starfield: {
    src: `${paths.img.backgrounds}/starfield.jpg`,
    width: 512 * 2,
    height: 512 * 2,
  },
};

export const musics = {
  gloryHammer: [
    {
      volume: 0.1,
      music1Params: {
        src: `${paths.audio.BGMs}/gh/gh-symphonic.mp3`,
      },
      music2Params: {
        src: `${paths.audio.BGMs}/gh/gh.mp3`,
      }
    },
  ],
  chaosWizard: [
    {
      volume: 0.1,
      music1Params: {
        src: `${paths.audio.BGMs}/gh/chaosWizards-symphonic.mp3`,
      },
      music2Params: {
        src: `${paths.audio.BGMs}/gh/chaosWizards.mp3`,
      }
    },
  ],
  universeOnFire: [
    {
      volume: 0.1,
      music1Params: {
        src: `${paths.audio.BGMs}/gh/universeOnFire-symphonic.mp3`,
      },
      music2Params: {
        src: `${paths.audio.BGMs}/gh/universeOnFire.mp3`,
      }
    },
  ],
  inHootsWeTrust: [
    {
      volume: 0.1,
      music1Params: {
        src: `${paths.audio.BGMs}/gh/inHootsWeTrust-symphonic.mp3`,
      },
      music2Params: {
        src: `${paths.audio.BGMs}/gh/inHootsWeTrust.mp3`,
      }
    },
  ],
  mastersOfTheGalaxy: [
    {
      volume: 0.1,
      music1Params: {
        src: `${paths.audio.BGMs}/gh/mastersOfTheGalaxy-symphonic.mp3`,
      },
      music2Params: {
        src: `${paths.audio.BGMs}/gh/mastersOfTheGalaxy.mp3`,
      }
    },
  ],
  hootsforce: [
    {
      volume: 0.1,
      music1Params: {
        src: `${paths.audio.BGMs}/gh/hootsforce-symphonic.mp3`,
      },
      music2Params: {
        src: `${paths.audio.BGMs}/gh/hootsforce.mp3`,
      }
    },
  ],
  battleForEternity: [
    {
      volume: 0.1,
      music1Params: {
        src: `${paths.audio.BGMs}/gh/battleForEternity-symphonic.mp3`,
      },
      music2Params: {
        src: `${paths.audio.BGMs}/gh/battleForEternity.mp3`,
      }
    },
  ],
};
